import React from 'react';

const PageHeader = ({bgImg,title,content}) => {
    return (
        <div className="page-header-area bg-img" style={{backgroundImage: `linear-gradient(90deg, rgba(245, 246, 252, 0.52), rgba(0, 0, 0, 0.73)), url(`+process.env.REACT_APP_BASE_URL+`${bgImg})`}}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 col-xl-8 m-auto text-center">
                        <div className="page-header-content-inner">
                            <div className="page-header-content">
                                <h2>{title}</h2>
                                <p dangerouslySetInnerHTML={{__html: content}}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageHeader;